<template>
  <div :class="$route.name">
    <Header />
    <div
      id="app-layout"
      :class="isMobile ? 'is-mobile':''"
    >
      <div class="container">
        <div class="section-header text-center mb-1 mb-sm-2">
          <h1 class="section-title mb-0 mb-sm-3">
            <span class="text-primary">SEO</span> Analyzer
          </h1>
          <p class="section-description is-large d-none d-sm-block">
            See how your website is reviewed by Search Engines. Can’t understand why your competition is <br> ranking above you? 
            Want to know what to do to beat them? Look no further, answers are in this <strong>FREE</strong> report! 
          </p>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mx-auto mb-1 mb-sm-3">
            <NavPills />
          </div>
        </div>
      </div>

      <transition
        :name="transitionName"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view />
      </transition>

      <div class="banner-wrapper text-center">
        <a href="https://www.accuranker.com/?aaid=FO5BCPGPKP6V ">
          <img
            src="@/assets/img/banners/600x300-light.png"
            alt="Accuranker"
          >
        </a>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import NavPills from '@/components/NavPills';

const isMobile = require('ismobilejs')

const DEFAULT_TRANSITION = 'slide';

export default {
  
  components: {
    Header,
    Footer,
    NavPills,
  },
  
  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      isMobile: isMobile.any
    }
  },

  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },

  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },
  }
}
</script>
<style lang="scss" scoped>
  #app-layout {
    padding: 20px 0;
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition-duration: 0.3s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    transform: translate(2em, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    transform: translate(-2em, 0);
  }
</style>

